import {Component, Input, Output, EventEmitter, OnInit, HostListener, OnDestroy} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {EMAIL_PATTERN, PHONE_NUMBER} from 'app/common';
import {AppToastrService, ClientsService, DictionaryService} from 'app/services';
import {Client, Dictionary, Member} from 'app/models';
import * as moment from 'moment';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-member-popup',
  templateUrl: './member.html'
})
export class MemberComponent implements OnInit, OnDestroy {
  @Input() client: Client;
  @Input() member: Member;
  @Input() index: number;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  emailCtrl: FormControl;
  firstNameCtrl: FormControl;
  secondNameCtrl: FormControl;
  lastNameCtrl: FormControl;
  birthdayCtrl: FormControl;
  phoneCtrl: FormControl;
  commentCtrl: FormControl;
  ageTypeCtrl: FormControl;
  form: FormGroup;
  submitting: boolean;
  submitPressed: boolean;
  ageCategories: Dictionary[];
  private subscr: Subscription;

  @HostListener('window:keyup', ['$event']) onKey(event) {
    if (event.keyCode === 27) {
      this.onClose();
    }
  }


  constructor(private toast: AppToastrService,
              private clientsService: ClientsService,
              private dictionaryService: DictionaryService,
              private fb: FormBuilder) {
  }

  ngOnInit() {
    this.prepareForm();
    this.getAgeCategories();
    this.subscr = this.emailCtrl.valueChanges.subscribe(data => {
      this.form.patchValue({
          email: data.replace(/\s/g, '')
        },
        {emitEvent: false}
      );
    });
  }

  ngOnDestroy() {
    if (this.subscr) {
      this.subscr.unsubscribe();
    }
  }

  private prepareForm() {
    const c = this.member;
    this.emailCtrl = this.fb.control(c ? c.email : '', [Validators.pattern(EMAIL_PATTERN)]);
    this.firstNameCtrl = this.fb.control(c ? c.firstName : '', [Validators.required]);
    this.secondNameCtrl = this.fb.control(c ? c.secondName : '');
    this.lastNameCtrl = this.fb.control(c ? c.lastName : '', [Validators.required]);
    this.birthdayCtrl = this.fb.control(c && c.birthday ? c.birthday.format('DD.MM.YYYY') : '',
      [Validators.required, Validators.pattern('^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\\d\\d$'),]);
    this.phoneCtrl = this.fb.control(c ? c.phone : '', [Validators.pattern(PHONE_NUMBER)]);
    this.ageTypeCtrl = this.fb.control(c && c.ageType ? c.ageType.id : '', [Validators.required, Validators.min(1)]);
    this.commentCtrl = this.fb.control(c ? c.comment : '');
    this.form = this.fb.group({
      email: this.emailCtrl,
      firstName: this.firstNameCtrl,
      secondName: this.secondNameCtrl,
      lastName: this.lastNameCtrl,
      birthday: this.birthdayCtrl,
      comment: this.commentCtrl,
      ageType: this.ageTypeCtrl,
      phone: this.phoneCtrl,
    });
  }

  onClose() {
    this.notify.emit({type: 'close'});
    this.form.reset();
  }

  getAgeCategories() {
    this.dictionaryService.getAgeCategories().subscribe((res) => {
      if (res) {
        this.ageCategories = res;
      }
    });
  }

  touchEvent() {
    this.birthdayCtrl.markAsTouched();
  }

  onSubmit() {
    this.submitting = true;
    this.touchEvent();
    if (this.form.valid && !this.submitPressed) {
      this.submitPressed = true;
      const data: any = {
        id: this.member ? this.member.id : null,
        clientId: this.client ? this.client.id : null,
        email: this.emailCtrl.value,
        first_name: this.firstNameCtrl.value,
        second_name: this.secondNameCtrl.value,
        last_name: this.lastNameCtrl.value,
        birthday: moment(this.birthdayCtrl.value, 'DD.MM.YYYY').toISOString(),
        branch: this.client.branch,
        comment: this.commentCtrl.value,
        city: this.client.city,
        phone:  this.phoneCtrl.value,
        age_category_id: this.ageTypeCtrl.value,
        manager: this.client && this.client.manager ? {
          id: this.client.manager.id
          } : {}
        // manager_id: this.client && this.client.manager ? this.client.manager.id : null,
      };

      this.clientsService[data.id ? 'updateMember' : 'createMember'](data).subscribe((res) => {
        if (res) {
          this.notify.emit({
            type: this.member && this.member.id ? 'updateMember' : 'createMember',
            data: res,
            index: this.index
          });
          this.submitting = false;
          this.toast.showToast({title: this.member && this.member.id ? 'Данные связанного лица успешно изменены' : 'Связанное лицо успешно создано'});
        }
      }, (err) => {
        this.submitPressed = false;
        this.submitting = false;
        if (err.error.code === 'client_exists') {
          this.notify.emit({type: 'recreate', data});
        } else if (err.error.code === 'client_exists') {
          this.notify.emit({type: 'recreate', data});
        } else {
          this.toast.showToastFromError(err);
        }
      });
    } else {
      this.submitPressed = false;
    }
  }
}
